<script setup lang="ts">
type Mode = "list" | "map";

const model = defineModel<Mode>({ required: true });
defineProps<{ inline?: boolean }>();

const { t } = useI18n();

const label = computed(() => (model.value === "list" ? t("ui.map.show") : t("ui.list.show")));
const icon = computed(() => (model.value === "list" ? "icon:map" : "icon:list"));

function toggle() {
  model.value = model.value === "list" ? "map" : "list";
  window.scrollTo({ top: 0, behavior: "instant" });
}
</script>

<template>
  <AppMobileFloatingButton v-if="inline" :label="label" :icon="icon" @click="toggle" />
  <div v-else class="absolute inset-0 lg:hidden pointer-events-none z-30 pb-6">
    <div class="sticky top-0 -mt-(--ui-header-height) h-dvh p-4 sm:px-6 flex flex-col justify-end">
      <AppMobileFloatingButton :label="label" :icon="icon" @click="toggle" class="pointer-events-auto" />
    </div>
  </div>
</template>
